import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGetTicketsList } from "../../../lib/queries/queriesAndMutations";
import Buttons from "../../Buttons";
import Loader from "../../shared/Loader";
import Pagination from "../../shared/Pagination";
import Hint from "../Hint";
import TicketCard from "./TicketCard";

const TicketList = () => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const {
    data: ticketsList,
    isPending,
    refetch,
    isRefetching,
  } = useGetTicketsList({
    currentPage,
    pageSize,
  });

  const handleNewAccount = useCallback(() => navigate("/tickets/new"), [navigate]);

  if (isPending || isRefetching) {
    return (
      <div className="w-full h-full flex-center            min-h-[400px] ">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {ticketsList?.data.count > 0 ? (
        <div className="w-full  p-2 md:p-6 overflow-y-scroll vanda  pb-16  ">
          <div className="w-full flex flex-col items-end   rounded-v-lg gap-4">
            <div className="w-full flex justify-between items-center">
              <div onClick={handleNewAccount}>
                <Buttons
                  btnStyleparam={"mainbutton"}
                  fontsize={"dashboard"}
                  bgcolor={"primary"}
                  txtcolor={"primary"}
                  children={"تیکت جدید"}
                  lefticon={false}
                  righticon={false}
                  borders={"secondary"}
                  bRadius={"xl"}
                />
              </div>
            </div>

            <div className="w-full  grid grid-cols-1  lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 gap-4 rounded-[16px]   ">
              {ticketsList?.data.count > 0 ? (
                ticketsList?.data.items.map((item, index) => (
                  <TicketCard
                    key={index}
                    rowData={item}
                    index={index}
                    refetch={refetch} // Pass the refetch function
                  />
                ))
              ) : (
                <p>آیتمی وجود ندارد ...</p>
              )}
            </div>
          </div>

          <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
            <Pagination
              onPageChange={onPageChange}
              totalCount={ticketsList?.data?.count || 0}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-primary-40"
            />
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex justify-center items-center ">
          <div className="flex flex-col  gap-6 p-6 bg-white max-w-[700px]   rounded-xl shadow-md w-fit">
            <Hint
              hintStyle={"entry"}
              response={"mobile"}
              hintImage={true}
              title={"به بخش پشتیبانی خوش آمدید!"}
              entry={"flex justify-center items-center"}
            >
              <p className="flex justify-center items-center mb-4">
                هنوز تیکتی ایجاد نشده است. برای افزودن اولین تیکت، کافی است بر روی دکمه زیر کلیک نمایید و
                ادامه فرایند را طی کنید.
              </p>
              <div onClick={handleNewAccount}>
                <Buttons
                  btnStyleparam={"mainbutton"}
                  fontsize={"dashboard"}
                  bgcolor={"primary"}
                  txtcolor={"primary"}
                  children={"افزودن تیکت جدید"}
                  lefticon={false}
                  righticon={false}
                  borders={"secondary"}
                  bRadius={"xl"}
                />
              </div>
            </Hint>
          </div>
        </div>
      )}
    </>
  );
};

export default TicketList;
